import { FC, memo } from 'react';
import { useLeadsDatabaseContext } from '@pages/LeadsDatabase/context';

import { Tabs } from '../enums';

import MyLeads from './MyLeads';
import ScrapekingDb from './ScrapekingDb';

const ActiveTab: FC = () => {
  const { tab } = useLeadsDatabaseContext();
  return (
    <div>
      {tab === Tabs.MY_LEADS ? <MyLeads /> : null}
      {tab === Tabs.SCRAPEKING_DB ? <ScrapekingDb /> : null}
    </div>
  );
};

export default memo(ActiveTab);
